import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IAggregateBusinessRepository } from '@/coreInfrastructureModule/interfaces/IAggregateBusinessRepository';
import { PutLastCheckedAdapter } from '../adapters/putLastCheckedAdapter';
import { ILastCheckedResponse } from '../domains/entities/lastChecked';

/**
 * 最終チェック情報を更新するユースケース
 */
export class PutLastCheckedUseCase {
  private repository: IAggregateBusinessRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IAggregateBusinessRepository) {
    this.repository = repository;
  }

  /**
   * 最終チェック情報を更新する
   * @param aggregateBusinessId - 集計ID
   */
  public async execute(aggregateBusinessId: string): Promise<INetworkResult<ILastCheckedResponse, Error>> {
    try {
      const result = await this.repository.putLastChecked(aggregateBusinessId);
      switch (result.status.type) {
        case 'success':
          return {
            status: {
              type: 'success',
              data: PutLastCheckedAdapter.adapt(result.status.data),
            },
          };
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }
    } catch (error) {
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  }
}
